import * as t from 'io-ts';
import { nonEmptyString } from '../utils';

const OAuth = t.exact(t.interface({
  clientId: nonEmptyString,
  clientSecret: nonEmptyString,
}), 'OAuth');

export type IOAuth = t.TypeOf<typeof OAuth>;

export default OAuth;
